'use client';

import dynamic from 'next/dynamic';

const ShortcutTooltip = dynamic(
	() => import('./shortcut-tooltip-client').then((mod) => mod.ShortcutTooltipClient),
	{
		ssr: false,
	}
);

export { ShortcutTooltip };
